import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';


@Injectable()
export class TransactionPurposeTypeService {

  constructor( 
    private http: HttpClient, 
    private global: GlobalDataService) { }

createTransactionPurposeType(data: any){
      return this.http.post(this.global.httpUrl+"account/account-transaction-purpose-type", data); 
}

updateTransactionPurposeType(data: any, id: any){
      return this.http.put(this.global.httpUrl+"account/account-transaction-purpose-type/"+id, data); 
}

getTransactionPurposeType(isActive:number=-1){

     let isAvailable: string ="?active="+isActive;

     if(isActive==-1){
         isAvailable="";
     }

      return this.http.get(this.global.httpUrl+"account/account-transaction-purpose-type"+isAvailable);
}

getTransactionPurposeTypeById(id: string){
      return this.http.get(this.global.httpUrl+"account/account-transaction-purpose-type/"+id);
}

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/transaction_purpose_types/transaction-purpose-type.service.ts